import React from "react";

// styles
import styles from "./styles.module.scss";

// components
import Input from "./Input/Input";
import Button from "./Button/Button";
import Header from "./Header/Header";

const VerifyForm = ({ changeForm }) => {
  return (
    <form>
      <Header
        title="Enter Verification Code?"
        text={`${"Enter code that we have sent to your \nemail samxxxxx@email.com"}`}
        icon
        handleChange={() => changeForm(3)}
      />
      <div className="sm-space-20"></div>
      <div className={styles.verfiy_input_row}>
        <Input
          placeholder=""
          type="password"
          maxLength={1}
          style={{ textAlign: "center" }}
        />
        <Input
          placeholder=""
          type="password"
          maxLength={1}
          style={{ textAlign: "center" }}
        />
        <Input
          placeholder=""
          type="password"
          maxLength={1}
          style={{ textAlign: "center" }}
        />
        <Input
          placeholder=""
          type="password"
          maxLength={1}
          style={{ textAlign: "center" }}
        />
      </div>
      <div className="sm-space-200"></div>
      <Button label="VERIFY" fill handleClick={() => changeForm(5)} />
    </form>
  );
};

export default VerifyForm;
